const actions = {
	async load({ rootState }) {
		const env = rootState.env;
		const load = new Promise((resolve, reject) => {
			gapi.load('client:auth2', () => {
				const isSignin = isSignin => {
					if (isSignin) resolve(true);
					else gapi.auth2.getAuthInstance().signIn();
				};
				const params = {
					apiKey: env.gaKey,
					clientId: env.gClientId,
					discoveryDocs: [env.gaDiscoveryDocs],
					scope: env.gcScope,
				};
				gapi.client.init(params).then(() => {
					gapi.auth2.getAuthInstance().isSignedIn.listen(isSignin);
					isSignin(gapi.auth2.getAuthInstance().isSignedIn.get());
				});
			});
		});
		return await load;
	},
};

export default {
	namespaced: true,
	actions,
};
